import React from 'react'
import classNames from 'classnames'
import { Typeahead } from '@deal/components'
import { ChangeEvent, SuggestionSelectedEventData } from 'react-autosuggest'
import {
  AirportTypeaheadSearchComponent,
  AirportTypeaheadResultFragment
} from '#src/generated/graphql'
import Pin from './pin.svg'
import styles from './styles.css'

interface AirportTypeaheadInputState {
  value: string
}

interface AirportTypeaheadInputProps {
  label: string
  defaultValue?: {
    id: string
    displayName: string
  }
  onSetValue: (id: string, name: string) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  labelHidden?: boolean
  iconHidden?: boolean
  className?: string
  inputClassName?: string
  placeholder?: string
}

class AirportTypeaheadInput extends React.Component<
  AirportTypeaheadInputProps,
  AirportTypeaheadInputState
> {
  constructor(props: AirportTypeaheadInputProps) {
    super(props)

    this.state = {
      value: props.defaultValue ? props.defaultValue.id : ''
    }
  }

  public handleChange = (event: React.ChangeEvent<HTMLInputElement>, params?: ChangeEvent) => {
    if (params) {
      const { value } = this.state
      if (value && !params.newValue) {
        this.props.onSetValue('', '')
      }
      this.setState({ value: params.newValue })
    }

    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  public onSuggestionSelected = (
    _: React.FormEvent<any>,
    data: SuggestionSelectedEventData<AirportTypeaheadResultFragment>
  ) => {
    this.props.onSetValue(data.suggestion.id, data.suggestion.name)
  }

  public getSuggestionValue = (suggestion: AirportTypeaheadResultFragment) => suggestion.name

  render() {
    const { value } = this.state
    const { label, labelHidden, iconHidden, className, inputClassName, placeholder } = this.props

    const inputProps = {
      onChange: this.handleChange,
      className: classNames(styles.input, inputClassName),
      value: value ? value : this.props.defaultValue ? this.props.defaultValue.displayName : '',
      autoFocus: false
    }

    return (
      <AirportTypeaheadSearchComponent
        variables={{
          query: {
            prefixSearch: value
          },
          first: 10
        }}
        skip={value.length === 0}
      >
        {({ data }) => {
          const results = data && data.airportTypeahead ? data.airportTypeahead.hits : []

          return (
            <div className={classNames(styles.flexContainer, className)}>
              <Typeahead
                suggestions={results}
                onSuggestionsFetchRequested={() => null}
                onSuggestionsClearRequested={() => null}
                onSuggestionSelected={this.onSuggestionSelected}
                inputProps={inputProps}
                getSuggestionValue={this.getSuggestionValue}
                textFieldProps={{
                  label,
                  labelHidden,
                  placeholder,
                  icon: iconHidden ? null : Pin,
                  display: 'standard'
                }}
              />
            </div>
          )
        }}
      </AirportTypeaheadSearchComponent>
    )
  }
}

export default AirportTypeaheadInput
